import { render, staticRenderFns } from "./SurgerySetPopup.vue?vue&type=template&id=1df464be"
import script from "./SurgerySetPopup.vue?vue&type=script&lang=js"
export * from "./SurgerySetPopup.vue?vue&type=script&lang=js"
import style0 from "./SurgerySetPopup.vue?vue&type=style&index=0&id=1df464be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports